import Axios from 'axios'

function csrfToken () {
  return document.querySelector<HTMLMetaElement>('meta[name=csrf-token]')?.content
}

export const axios = Axios.create()

axios.defaults.headers.common['X-CSRF-Token'] = csrfToken()
axios.defaults.headers.common['User-Agent'] = 'bonitaetsmanager.de'

export const { CancelToken } = Axios
